package ru.villawonka.app.presentation.sharedviews.postList.viewmodel

import androidx.lifecycle.ViewModel
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.launch
import ru.villawonka.app.AppConfig
import ru.villawonka.app.domain.model.Deeplink
import ru.villawonka.app.domain.model.PostTypeDomain
import ru.villawonka.app.domain.service.FavoritesService
import ru.villawonka.app.presentation.model.PostUIModel
import ru.villawonka.app.presentation.model.getPostType
import ru.villawonka.app.resources.AppResources
import kotlin.coroutines.EmptyCoroutineContext

class PostListViewModel(
    private val favoritesService: FavoritesService,
): ViewModel() {

    private val coroutineScope = CoroutineScope(EmptyCoroutineContext + Dispatchers.Default)
    private val _events = MutableSharedFlow<PostListUIEvent>()
    val events = _events.asSharedFlow()

    fun onPostClick(post: PostUIModel) = coroutineScope.launch {
        _events.emit(
            PostListUIEvent.OpenPostCardScreen(
                postId = post.id,
                postType = post.getPostType()
            )
        )
    }

    fun onConversionDetailsClick(post: PostUIModel) = coroutineScope.launch {
        when (post) {
            is PostUIModel.Accommodation -> post.conversationDetails?.let {
                _events.emit(PostListUIEvent.OpenConversationDetailsScreen(it))
            }
        }
    }

    fun onLikeButtonClick(post: PostUIModel, isLiked: Boolean) = coroutineScope.launch {
        favoritesService.toggleLike(
            postId = post.id,
            postType = post.getPostType(),
            isLiked = isLiked
        )
    }

    fun onChatButtonClick(post: PostUIModel) = coroutineScope.launch {
        post.contactUsername?.let {
            _events.emit(PostListUIEvent.OpenExternalLink(
                link = Deeplink.Telegram.chat(
                    username = it,
                    text = AppResources.strings.helloMessage(
                        deeplink = Deeplink.Telegram.post(
                            postType = PostTypeDomain.ACCOMMODATION,
                            miniAppUrl = AppConfig.miniAppUrl,
                            postId = post.id
                        )
                    )
                )
            ))
        }
    }

    fun onCallButtonClick(post: PostUIModel) = coroutineScope.launch {
        post.contactPhoneNumber?.let {
            _events.emit(PostListUIEvent.PhoneCall(it))
        }
    }

    fun onScrollToUpButtonClick() = coroutineScope.launch {
        _events.emit(PostListUIEvent.ScrollToUp)
    }

    fun onImageEnlargeButtonClick(post: PostUIModel, selectedIndex: Int) = coroutineScope.launch {
        _events.emit(PostListUIEvent.OpenMediaSliderScreen(
            initialPage = selectedIndex,
            media = post.media
        ))
    }
}